import React from "react";
import "./TitleMobile.css";

const TitleMobile = (props) => {
    let title = props.title;
    let subtitle = props.subtitle;

    return (
        <React.Fragment>
            <div style={{
                marginLeft: "5%",
                marginTop: "10%",
            }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <div className="vertical-line-mobile" style={{marginRight:"15px"}}/>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <p className="title-mobile font-face-encode-sans-light">{title}</p>
                        <p className="subtitle-mobile font-face-encode-sans-bold">{subtitle}</p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TitleMobile;
